import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { AESService } from '../encryption/aes.service';

@Injectable()
export class ImageUploadService {
  maximumFileLimit:number = 5*1024*1024
  maximumFileLimitForVideo:number = 50*1024*1024
  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
   
  }
 
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  upload(user: any,isProductImage:boolean = false): Observable<any> {
    user['isProductImage'] = isProductImage
    return this.http.post<any>(this.config.baseURL + '/product/uploadImages', user, this.httpOptions)
      .map((res) => { return res }

      );
  }

  uploadVideo(data: any): Observable<any>{
    return this.http.post<any>(this.config.baseURL + '/product/uploadVideo', data)
        .map((res) => { return res }
        );
  }
}
